module.exports = "https://static.wanderu.com/static/media/chiku-uh-oh.7263c9cc.svg";